import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { Dropzone, FileItem, FullScreenPreview } from "@dropzone-ui/react";

import "./AddTransactionFileModal.css";
import okIcon from "../../../../assets/icons/new-icons/ok.svg";
import exitIcon from "../../../../assets/icons/new-icons/exit.svg";
// Firebase Start
import { getDownloadURL, uploadBytes } from "firebase/storage";
import { getStorage } from "firebase/storage";
import { ref } from "firebase/storage";
// Firebase End
const style = {
  position: "absolute",
  top: "37%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // width: "400px",
  bgcolor: "#fff",
  border: 0,
  outline: "none",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
  minHeight: "58vh",
};

const TransactionModal = (props) => {
  const { modalStatus, setModalStatus, files, setFiles, DealId } = props;
  const [localFiles, setLocalFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [imageSrc, setImageSrc] = useState(undefined);
  // let images = [];
  const handleClose = () => {
    setModalStatus(false);
  };
  const updateFiles = (incommingFiles) => {
    setLocalFiles(incommingFiles);
  };
  const onDelete = (id) => {
    setLocalFiles(localFiles.filter((x) => x.id !== id));
  };
  const handleSee = (imageSource) => {
    setImageSrc(imageSource);
  };

  const handleClean = (localFiles) => {};
  const updateNewFilesStatus = () => {
    let a = [...localFiles];
    a = a.map((file) => {
      return { ...file, uploadStatus: file.uploadStatus || "uploading" };
    });
    setLocalFiles(a);
  };
  const markAsUploaded = (__ID) => {
    let a = [...localFiles];
    a = a.map((file) => {
      return {
        ...file,
        uploadStatus: file.id === __ID ? "success" : file.uploadStatus,
      };
    });
    setLocalFiles([...a]);
  };
  const uploadImages = async () => {
    setIsUploading(true);
    let images = [];
    for (let index = 0; index < localFiles.length; index++) {
      if (
        localFiles[index].uploadStatus &&
        localFiles[index].uploadStatus !== "uploading"
      )
        continue;
      const { file, id, valid } = localFiles[index];
      const { type } = file;
      const __ext = type.split("/").pop();
      const __path = ref(getStorage(), `deals/${DealId}/${id}.${__ext}`);
      await uploadBytes(__path, file).then(async (snapshot) => {
        let downloadUrl = "";
        await getDownloadURL(snapshot.ref).then((url) => {
          downloadUrl = url;
          const fileObj = {
            name: snapshot.metadata.name,
            size: snapshot.metadata.size,
            time: snapshot.metadata.timeCreated,
            url: downloadUrl,
          };

          images.push(fileObj);

          markAsUploaded();
        });
      });
    }
    const oldFiles = files;
    const filesLength = files.length;
    let tempFiles = [...files];

    for (let i = 0; i < oldFiles.length; i++) {
      let j = 0;

      files.map((file, index) => {
        if (oldFiles[i].url !== file.url) {
          j++;
        }
      });
      if (j === filesLength) {
        tempFiles.push(oldFiles[i]);
      }
    }
    setFiles([...images, ...tempFiles]);

    uploadFinish();
  };
  const uploadStart = () => {
    setIsUploading(true);
    updateNewFilesStatus();
    uploadImages();
  };
  const uploadFinish = () => {
    setIsUploading(false);
    setModalStatus(false);
  };
  return (
    <Modal
      open={modalStatus}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} className={"Custom-Modal-Box"}>
        <div className="Transaction-file-model">
          <div className="Transaction-model-header">
            <p className="custom-heading">Add File</p>
            <div
              className="modal-close-icon"
              onClick={() => {
                setModalStatus(false);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                fill="currentColor"
                class="bi bi-x"
                viewBox="0 0 16 16"
              >
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </div>
          </div>
          <hr className="mb-4" />

          <div className="input-box">
            <Dropzone
              onChange={updateFiles}
              value={localFiles}
              onClean={handleClean}
              maxFiles={20}
              maxFileSize={2998000}
              accept=".png,image/*"
              uploadingMessage={"Uploading..."}
              clickable={!isUploading}
              header={!isUploading}
              // disableScroll
            >
              <figure className="figure-span">
                <svg
                  width="20"
                  height="23"
                  viewBox="0 0 15 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.4211 14.7273H4.73684C4.30263 14.7273 3.93105 14.5672 3.62211 14.247C3.31263 13.9263 3.15789 13.5409 3.15789 13.0909V1.63636C3.15789 1.18636 3.31263 0.801 3.62211 0.480273C3.93105 0.160091 4.30263 0 4.73684 0H9.61184C9.82237 0 10.0232 0.0409091 10.2142 0.122727C10.4047 0.204545 10.5724 0.320455 10.7171 0.470455L14.5461 4.43864C14.6908 4.58864 14.8026 4.76236 14.8816 4.95982C14.9605 5.15782 15 5.36591 15 5.58409V13.0909C15 13.5409 14.8455 13.9263 14.5366 14.247C14.2271 14.5672 13.8553 14.7273 13.4211 14.7273ZM1.57895 18C1.14474 18 0.773158 17.8399 0.464211 17.5197C0.154737 17.199 0 16.8136 0 16.3636V5.72727C0 5.49545 0.0757896 5.301 0.227369 5.14391C0.378421 4.98736 0.565789 4.90909 0.789474 4.90909C1.01316 4.90909 1.20079 4.98736 1.35237 5.14391C1.50342 5.301 1.57895 5.49545 1.57895 5.72727V16.3636H9.47368C9.69737 16.3636 9.885 16.4422 10.0366 16.5993C10.1876 16.7558 10.2632 16.95 10.2632 17.1818C10.2632 17.4136 10.1876 17.6078 10.0366 17.7644C9.885 17.9215 9.69737 18 9.47368 18H1.57895ZM10.2632 5.72727H13.4211L9.47368 1.63636V4.90909C9.47368 5.14091 9.54947 5.33536 9.70105 5.49245C9.8521 5.649 10.0395 5.72727 10.2632 5.72727Z"
                    fill="#4E36A8"
                  />
                </svg>
                <span className="custom-label">Drop Your File Here</span>
              </figure>
              {localFiles.map((file) => (
                <FileItem
                  {...file}
                  preview
                  onDelete={onDelete}
                  onSee={handleSee}
                  resultOnTooltip
                  info
                  hd
                />
              ))}

              <FullScreenPreview
                imgSource={imageSrc}
                openImage={imageSrc}
                onClose={(e) => handleSee(undefined)}
              />
            </Dropzone>
          </div>
        </div>

        <Box className="add-deal-btn-container mt-4">
          {isUploading ? (
            <div class="spinner-border spinner-border-sm" role="status">
              <span class="sr-only"></span>
            </div>
          ) : (
            <>
              <button
                className="close-modal-btn"
                onClick={() => {
                  setModalStatus(false);
                }}
              >
                Cancel
              </button>
              <button className="form-submit-button" onClick={uploadImages}>
                Save
              </button>
            </>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default TransactionModal;
